export default __webpack_public_path__ + "static/media/health-data-hero.9f60ff95.svg";